import { handleActions } from 'redux-actions';

const initialState = {
  username: '',
  user_id: '',
  firstName: '',
  lastName: '',
  fullName: '',
  email_id: '',
  cities: [],
  states: [],
  filteredStates: [],
  locations: [],
  company_details: {},
  error: null,
  otp: {
    status: 'idle',
    message: '',
    failureAttempts: 0,
  },
};

const AuthReducer = handleActions(
  {
    LOGIN_SUCCESS: (state, action) => {
      return {
        ...state,
        username: action.payload.username,
        user_id: action.payload.user_id,
        firstName: action.payload.first_name,
        lastName: action.payload.last_name,
        fullName: action.payload.full_name,
        email_id: action.payload.email_id ?? action.payload.username,
        error: null,
      };
    },
    GET_USER_INFO_SUCCESS: (state, action) => {
      return {
        ...state,
        user_id: action.payload.user_id,
        firstName: action.payload.first_name,
        lastName: action.payload.last_name,
        fullName: action.payload.full_name,
        email_id: action.payload.email ?? action.payload.username,
      };
    },
    GET_MATCHING_CITIES: (state, action) => {
      return {
        ...state,
        cities: action.payload.response,
      };
    },
    GET_ALL_STATES: (state, action) => {
      return {
        ...state,
        states: action.payload.states,
        filteredStates: action.payload.states,
      };
    },
    GET_COMPANY_INFO_SUCCESS: (state, action) => {
      return {
        ...state,
        company_details: action.payload.company_details,
      };
    },
    FILTER_LOCATIONS: (state, action) => {
      return {
        ...state,
        locations: action.payload.locations,
      };
    },
    SET_AUTH_ERROR: (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    },
    STATE_CLEANUP: (state, action) => {
      return {
        ...state,
        ...initialState,
      };
    },
    OTP_REQUESTED: (state, action) => {
      return {
        ...state,
        otp: {
          ...state.otp,
          status: 'send',
          message: action.payload.message,
        },
      };
    },
    OTP_LOGIN: (state, action) => {
      return {
        ...state,
        otp: {
          ...state.otp,
          status: 'success',
          message: action.payload.message,
        },
        error: null,
      };
    },
    OTP_FAILURE: (state, action) => {
      let customMessage = 'OTP verification failed.';
      const error = action.payload.error?.toLowerCase() || '';
      let isStatus = 'idle';

      if (error.includes('expired')) {
        customMessage = 'The code you have entered has expired';
        isStatus = 'expired';
      } else if (error.includes('invalid')) {
        isStatus = 'invalid';
        customMessage = 'The code you have entered is incorrect';
      } else if (error.includes('temporarily locked')) {
        isStatus = 'Account Locked';
        customMessage = ' Your account has been locked, due to multiple failed login attempts. ';
      } else {
        isStatus = 'idle';
        customMessage = '';
      }

      return {
        ...state,
        otp: {
          status: isStatus,
          message: customMessage,
          failureAttempts: state.otp.failureAttempts + 1,
        },
      };
    },
  },
  initialState,
);

export default AuthReducer;
